var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.49 179.23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#2e4369;}.cls-2,.cls-4,.cls-6{stroke:#fff;}.cls-2{stroke-linecap:round;stroke-linejoin:round;}.cls-3{fill:#fff;}.cls-4,.cls-6{fill:none;stroke-miterlimit:10;}.cls-4{stroke-width:0.48px;}.cls-5,.cls-7{fill:#33b8ce;}.cls-7{font-size:15px;font-family:Almaq-Refined, Almaq;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 21") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "85.16 145.11 84.34 141.67 104.66 129.66 128.54 130.64 129.29 133.83 126.2 135.3 106.19 135.41 87.89 145.04 85.16 145.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "102.49 134.28 83.71 144.35 75.33 111.57 94.11 101.5 102.49 134.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "129.99 132.52 108.68 132.7 100.3 99.91 121.61 99.74 129.99 132.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M108.67,132.67c-.32-1.25-2-1.91-3.67-1.47s-2.83,1.8-2.51,3.05l-8.4-32.86c-.32-1.25.8-2.62,2.51-3.06s3.35.23,3.67,1.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M129.29,133.83l-20.63.17a6.88,6.88,0,0,1-2.34,1.17.33.33,0,0,0-.17.09.3.3,0,0,0-.19,0,6.67,6.67,0,0,1-2.61.09l-18.19,9.76c2.62.24,3.59,4.36,3.59,4.36l.86-.45.42,1.27s11.26-6.67,15.63-14a3,3,0,0,0,.53-.86,5.07,5.07,0,0,0,1.51.75c7.45,4.09,20,4.52,20,4.52l-.24-1.29.83,0S127.11,135.29,129.29,133.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M91.32,151.14s12.42-9.47,14.86-15.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "36.58 144.4 37.21 140.91 60.64 138.08 82.12 148.56 81.53 151.78 78.11 151.89 59.73 143.96 39.11 145.43 36.58 144.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.8 141.44 35.55 143.12 41.04 109.73 62.29 108.04 56.8 141.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "82.69 150.87 63.1 142.47 68.59 109.08 88.18 117.47 82.69 150.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.11,142.44c.21-1.27-1-2.54-2.77-2.82s-3.32.51-3.53,1.79l5.5-33.47c.21-1.28,1.79-2.08,3.53-1.79s3,1.55,2.77,2.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M81.53,151.78l-19-8.13a6.75,6.75,0,0,1-2.61.14.27.27,0,0,0-.19,0,.28.28,0,0,0-.18-.07,6.75,6.75,0,0,1-2.43-1l-20.57,1.63c2.3,1.27,1.53,5.43,1.53,5.43l1-.06L39,151.09s13-1.59,19.94-6.57a3,3,0,0,0,.83-.56,5.41,5.41,0,0,0,1.09,1.29C66,152,77.27,157.39,77.27,157.39l.3-1.27.77.31S78.94,152.25,81.53,151.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.8,152.39s15.17-3.69,20-8.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M76.18,158.46S63,150.11,60,144"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "1.03 147.34 2.8 144.27 25.81 149.55 42.46 166.69 40.82 169.52 37.56 168.47 22.96 154.77 3.06 149.16 1.03 147.34"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "21.06 151.41 0.5 145.79 16.98 116.23 37.54 121.85 21.06 151.41"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.22 169.06 26.64 154.51 43.12 124.96 58.7 139.5 42.22 169.06"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.65,154.49c.63-1.13-.11-2.74-1.65-3.6s-3.3-.64-3.93.49l16.52-29.62c.63-1.13,2.39-1.35,3.93-.49s2.28,2.47,1.65,3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M40.82,169.52,25.73,155.44a6.71,6.71,0,0,1-2.5-.75.28.28,0,0,0-.19-.05s-.06-.09-.14-.14a6.73,6.73,0,0,1-2-1.73L1,147.34c1.74,2-.39,5.62-.39,5.62l.93.27L1,154.44s12.76,2.91,21,.58a2.7,2.7,0,0,0,1-.25,5.4,5.4,0,0,0,.59,1.59c2.58,8.08,11.36,17,11.36,17l.71-1.1.62.56S38.23,169.08,40.82,169.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "45.29 171.59 44.55 168.13 65.18 156.64 89.02 158.22 89.69 161.43 86.57 162.82 66.56 162.43 48.02 171.6 45.29 171.59"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "62.89 161.21 43.86 170.8 36.31 137.82 55.34 128.22 62.89 161.21"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "90.43 160.14 69.11 159.78 61.56 126.79 82.88 127.16 90.43 160.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M69.11,159.75c-.29-1.26-1.92-2-3.63-1.57s-2.88,1.74-2.59,3l-7.57-33.06c-.29-1.27.87-2.61,2.59-3s3.34.31,3.63,1.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M89.69,161.43l-20.63-.35a6.75,6.75,0,0,1-2.36,1.11.38.38,0,0,1-.37.08,6.66,6.66,0,0,1-2.61,0l-18.43,9.29c2.61.31,3.48,4.45,3.48,4.45l.87-.43L50,176.9s11.42-6.39,16-13.63a2.92,2.92,0,0,0,.55-.84,5,5,0,0,0,1.49.79c7.34,4.27,19.83,5,19.83,5l-.21-1.29h.83S87.48,162.84,89.69,161.43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "86.98 175.12 85.48 171.91 103.02 156.11 126.61 152.32 127.98 155.29 125.25 157.35 105.66 161.44 89.64 174.51 86.98 175.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "101.81 161.06 85.4 174.67 70.67 144.21 87.08 130.6 101.81 161.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "128.41 153.87 107.56 158.28 92.82 127.82 113.68 123.41 128.41 153.87"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M107.54,158.26c-.56-1.16-2.3-1.49-3.89-.72s-2.42,2.34-1.85,3.5L87,130.5c-.56-1.16.27-2.73,1.85-3.49s3.33-.45,3.9.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M128,155.29l-20.19,4.27a6.76,6.76,0,0,1-2.05,1.61.33.33,0,0,0-.15.13.32.32,0,0,0-.19,0,6.81,6.81,0,0,1-2.54.61L87,175.12c2.61-.28,4.38,3.56,4.38,3.56l.75-.61.67,1.16s9.7-8.77,12.53-16.85a3.1,3.1,0,0,0,.35-.94,5.35,5.35,0,0,0,1.63.43c8.1,2.53,20.44.46,20.44.46l-.49-1.21.81-.19S126.14,157.16,128,155.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "60.4 133.07 62.24 130.04 85.11 135.89 101.33 153.44 99.62 156.23 96.39 155.09 82.14 141.04 62.38 134.94 60.4 133.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "80.32 137.63 59.9 131.5 77.11 102.37 97.52 108.49 80.32 137.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "101.03 155.8 85.81 140.88 103.02 111.74 118.24 126.66 101.03 155.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.83,140.85c.65-1.11,0-2.74-1.56-3.64s-3.28-.72-3.94.4L97.58,108.4c.66-1.11,2.42-1.29,3.94-.39s2.21,2.52,1.56,3.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M99.62,156.23,84.88,141.78A6.83,6.83,0,0,1,82.4,141a.26.26,0,0,0-.19-.05.27.27,0,0,0-.13-.14A6.83,6.83,0,0,1,80.16,139L60.4,133.07c1.68,2-.54,5.61-.54,5.61l.93.29-.6,1.2s12.68,3.22,21,1.1a3,3,0,0,0,1-.23,5,5,0,0,0,.54,1.6c2.39,8.15,10.94,17.28,10.94,17.28l.74-1.08.6.57S97,155.73,99.62,156.23Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "4.14 122.11 5.49 118.84 29 121 47.78 135.78 46.53 138.8 43.16 138.19 26.87 126.56 6.39 123.66 4.14 122.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "24.53 123.48 3.41 120.65 15.8 89.16 36.93 91.99 24.53 123.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "47.86 138.15 30.48 125.82 42.87 94.33 60.26 106.66 47.86 138.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M30.48,125.79c.48-1.2-.47-2.7-2.11-3.35s-3.35-.19-3.83,1L37,91.89c.47-1.2,2.19-1.65,3.83-1s2.58,2.15,2.11,3.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M46.53,138.8,29.7,126.86a6.77,6.77,0,0,1-2.58-.42.3.3,0,0,0-.2,0s-.06-.08-.15-.12a6.58,6.58,0,0,1-2.17-1.45L4.14,122.11c2,1.73.36,5.63.36,5.63l1,.15-.4,1.27s13,1.18,20.88-2.22a3,3,0,0,0,.93-.38,5.14,5.14,0,0,0,.79,1.49c3.64,7.67,13.52,15.34,13.52,15.34l.57-1.18.68.47S43.9,138.71,46.53,138.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M57.09,69.61l-5.73-2s9.27-9.72,14.24-21.75a45.51,45.51,0,0,0,2.94-22.95l34.05,13S104.75,46,99.85,58.36c-6.09,15.3-14.44,22.28-14.44,22.28L64.24,72.35s0-1.62,2-6.78-.2-13.84-1.72-9.18a44.59,44.59,0,0,1-7.75,14.06C55,72.68,56.12,79.09,58,83.74a29,29,0,0,1,1.83,10.6,61.14,61.14,0,0,1-1.33,11.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M73.19,75.87a37.9,37.9,0,0,1-2.83,8.48,24,24,0,0,0-1.83,11.48c.31,3.77.87,9,1.3,13.83"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "matrix(0.48, -0.88, 0.88, 0.48, 77.99, 74)"
  }, "HELP")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/Icon3.cd7ef210bb8475bf515aac1f0a244814.svg";
export { ForwardRef as ReactComponent };